// extracted by mini-css-extract-plugin
export default {"toggle":"ProjectContentToggle_toggle__mzu6x","option":"ProjectContentToggle_option__Afxe6","optionActive":"ProjectContentToggle_optionActive__xUbdF"};